import DotNetObject = DotNet.DotNetObject;

export const UserSettingProfileService = (() => {
  let dotNetObj: DotNetObject;

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const insert = async (subFolderPath: string, fileName: string, fileContents: string): Promise<boolean> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<boolean>('InsertAsync', subFolderPath, fileName, fileContents);
    } else {
      throw 'UserProfileSetting DotNet Object Reference has not yet been implemented';
    }
  };

  const get = async <T extends object>(subFolderPath: string, fileName: string): Promise<T> => {
    if (dotNetObj) {
      const fileContents: string = await dotNetObj.invokeMethodAsync<string>('GetFileContentsAsync', subFolderPath, fileName);

      return <T>JSON.parse(fileContents);
    } else {
      throw 'UserProfileSetting DotNet Object Reference has not yet been implemented';
    }
  };

  const update = async (subFolderPath: string, fileName: string, fileContents: string): Promise<boolean> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<boolean>('UpdateAsync', subFolderPath, fileName, fileContents);
    } else {
      throw 'UserProfileSetting DotNet Object Reference has not yet been implemented';
    }
  };

  const deleteItem = async (subFolderPath: string, fileName: string): Promise<boolean> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<boolean>('DeleteAsync', subFolderPath, fileName);
    } else {
      throw 'UserProfileSetting DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    insert,
    get,
    update,
    deleteItem,
  };
})();
